import { forkJoin, Observable, of, switchMap } from 'rxjs';
import { ApiResponce } from '../../Shared/interfaces/apiResponce.interface';
import { SharedService } from '../../Shared/services/shared.service';
import { AddUser } from '../../Shared/interfaces/addUser.interface';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AddUserUtility {
  constructor(private sharedS: SharedService) {}
  //============================================================================
  //=================  Add User  Common Funtion Call  ==========================
  //============================================================================

  getActiveAddressId(userDetailVal: any, activeId: number): number {
    if (!userDetailVal) return 0;
    if (
      !Array.isArray(userDetailVal.addresses) ||
      userDetailVal.addresses.length < 1
    ) {
      return 0;
    }
    const address = userDetailVal.addresses.find(
      (address: any) => address.id === activeId
    );

    if (!address && userDetailVal.addresses.length > 0) {
      return userDetailVal.addresses[0].id;
    }
    
    return address?.id;
  }

  //============================================================================
  //=================  Add User  Api Call  ================================
  //============================================================================

  addUserWithAddress(userDetailVal: any): Observable<any> {
    return this.callAddEditUserApi(userDetailVal).pipe(
      switchMap((addUserResponse: ApiResponce) => {
        const customerId = addUserResponse.Data.customer_id ?? '';
        return forkJoin({
          addUserResponse: of(addUserResponse),
          addAddressResponse: this.callAddEditAddressApi(
            customerId,
            userDetailVal,
            ''
          ),
        });
      })
    );
  }

  callAddEditUserApi(
    userDetailVal: any,
    customer_id?: string | null,
    branch_id?:any
  ): Observable<ApiResponce> {
    let AddUserFormData: AddUser = {
      ...userDetailVal,
      gender: userDetailVal.gender.id ?? '1',
      customer_id: customer_id ?? '',
      restaurant_branch_id:branch_id

    };
    return this.sharedS.sendPostRequest('add_edit_customer', AddUserFormData);
  }

  callAddEditAddressApi(
    customer_id: string,
    userDetailVal: any,
    address_id: string
  ): Observable<ApiResponce> {
    let AddAddressFormData = {
      address_id: address_id,
      address_type_id: userDetailVal.address_type ?? null,
      address1: `${userDetailVal.street ?? ''}`,
      latitude: userDetailVal.latitude ?? null,
      longitude: userDetailVal.longitude ?? null,
      customer_id: customer_id,
    };

    return this.sharedS.sendPostRequest(
      'add_edit_customer_address',
      AddAddressFormData
    );
  }
}
